import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
/**
 * Returns the country code and optionally the region name & region code of the
 * geolocation of the current IP.
 *
 * @param {String} mpacBaseUrl
 * @returns GeoIP region details
 */
export const getCurrentGeoIPRegion = mpacBaseUrl => fetchOk("".concat(mpacBaseUrl, "/rest/2/geoip")).then(response => response.json());